module.exports = __webpack_public_path__ + "img/diners-club.0e904d8a.svg";